import { IPaths } from 'Shared/Core/ApiPath/IPaths';

export const LifeInsuApiPaths: IPaths = {
  InsurancePolicyInfo: {
    GetInsurancePolicyInfoDetail: 'InsurancePolicyInfo/GetDetail',
  },
  PremiumInstallment: {
    GetAllPremiumInstallmentPaidPagedFilter: 'PremiumInstallment/GetAllPremiumInstallmentPaidPagedFilter',
    GetAllPremiumInstallmentUnPaidPagedFilter: 'PremiumInstallment/GetAllPremiumInstallmentUnPaidPagedFilter',
    CreatePremiumInstallment: 'PremiumInstallment/CreatePremiumInstallment',
    GetPayPremiumInstallmentConfig: 'PremiumInstallment/GetPayPremiumInstallmentConfig',
  },
  Loan: {
    GetAllLoanPaidPagedFilter: 'Loan/GetAllLoanPaidPagedFilter',
    GetAllLoanUnPaidPagedFilter: 'Loan/GetAllLoanUnPaidPagedFilter',
    CreateLoan: 'Loan/CreateLoan',
    GetActiveLoan: 'Loan/GetActiveLoan',
  },
};
